// client/src/App.js
import { HashRouter, Routes, Route } from 'react-router-dom';

import Home from './Home';
import LandingPage from './LandingPage';
import SalesPage from './SalesPage';
import MobilePage from './MobilePage';
import LegalPage from './LegalPage';
import MobileLegalPage from './MobileLegalPage';
import SignupComplete from './SignupComplete';
import RenewMembership from './RenewMembership';
import PublicPage from './PublicPage';
import Dashboard from './Dashboard';
import Backend from './Backend';
import DealerDashboard from './DealerDashboard';
import Wallets from './Wallets';
import Players from './Players';
import Game from './Game';
import Dealers from './Dealers';
import Admin from './Admin';
import Data from './Data';
import Book from './Book';
import SoftwareGuide from './SoftwareGuide';
import TournamentsHome from './TournamentsHome';
import TournamentCreate from './TournamentCreate';
import TournamentDashboard from './TournamentDashboard';
import TournamentManager from './TournamentManager';
import TournamentPlayers from './TournamentPlayers';
import TournamentPoints from './TournamentPoints';
import TournamentScreen from './TournamentScreen';
import TournamentTableView from './TournamentTableView';
import Referrals from './Referrals';
import Schedule from './Schedule';
import AcceptInvite from './AcceptInvite.jsx';
import Master from './Master.jsx';
import MainInvite from './MainInvite.jsx';
import DealerInvite from './DealerInvite.jsx';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/"                           element={<LandingPage />} />
        <Route path="/sales"                      element={<SalesPage />} />
        <Route path="/pricing"                    element={<SalesPage />} />
        <Route path="/faq"                        element={<SalesPage />} />
        <Route path="/mobile"                     element={<MobilePage />} />
        <Route path="/mobile/privacy"             element={<MobileLegalPage type="privacy" />} />
        <Route path="/mobile/support"             element={<MobileLegalPage type="support" />} />
        <Route path="/mobile-privacy"             element={<MobileLegalPage type="privacy" />} />
        <Route path="/mobile-support"             element={<MobileLegalPage type="support" />} />
        <Route path="/login"                      element={<Home />} />
        <Route path="/signup-complete"            element={<SignupComplete />} />
        <Route path="/renew-membership"           element={<RenewMembership />} />
        <Route path="/terms"                      element={<LegalPage type="terms" />} />
        <Route path="/privacy"                    element={<LegalPage type="privacy" />} />
        <Route path="/acceptable-use"             element={<LegalPage type="acceptableUse" />} />
        <Route path="/invite/:token" element={<AcceptInvite />} />
        <Route path="/mainInvite/:token" element={<MainInvite />} />
        <Route path="/dealerInvite/:token" element={<DealerInvite />} />
        <Route path="/master" element={<Master />} />
        <Route path="/:cardroom"                element={<PublicPage />} />
        <Route path="/:cardroom/dashboard"      element={<Dashboard />} />
        <Route path="/:cardroom/backend"      element={<Backend />} />
        <Route path="/:cardroom/dealerdashboard" element={<DealerDashboard />} />
        <Route path="/:cardroom/wallets"      element={<Wallets />} />
        <Route path="/:cardroom/players"      element={<Players />} />
        <Route path="/:cardroom/game"      element={<Game />} />
        <Route path="/:cardroom/dealers"      element={<Dealers />} />
        <Route path="/:cardroom/admin"      element={<Admin />} />
        <Route path="/:cardroom/guide"      element={<SoftwareGuide />} />
        <Route path="/:cardroom/data"      element={<Data />} />
        <Route path="/:cardroom/book"      element={<Book />} />
        <Route path="/:cardroom/tournamentsHome" element={<TournamentsHome />} />
        <Route path="/:cardroom/tournamentDashboard" element={<TournamentDashboard />} />
        <Route path="/:cardroom/tournamentPlayers" element={<TournamentPlayers />} />
        <Route path="/:cardroom/tournamentPoints" element={<TournamentPoints />} />
        <Route path="/:cardroom/tournamentsCreate" element={<TournamentCreate />} />
        <Route path="/:cardroom/tournaments/:id/manage" element={<TournamentManager />} />
        <Route path="/:cardroom/tournaments/:id/display" element={<TournamentScreen />} />
        <Route path="/:cardroom/tournaments/:id/tables" element={<TournamentTableView />} />
        <Route path="/:cardroom/referrals" element={<Referrals />} />
        <Route path="/:cardroom/schedule" element={<Schedule />} />
      </Routes>
    </HashRouter>
  );
}
